import axios from 'axios';

// const baseURL = localStorage.getItem('authurl');
const baseURL = localStorage.getItem('dburl');

const instance = axios.create({
  baseURL: baseURL + 'api/'
})

export default instance
